/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockOutboundDetailResVo
 */
export interface StockOutboundDetailResVo {
    /**
     * 订单编号
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    orderCode?: string;
    /**
     * 订单类型
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    orderTypeName?: string;
    /**
     * 申请类别编码，见 RequestTypeEnum
     * @type {number}
     * @memberof StockOutboundDetailResVo
     */
    requestType?: number;
    /**
     * 申请类别名称（按当前语言）
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    requestTypeName?: string;
    /**
     * 出库日期
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    outboundDate?: string;
    /**
     * 数量
     * @type {number}
     * @memberof StockOutboundDetailResVo
     */
    skuNumber?: number;
    /**
     * 单品规格
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    packageSpecification?: string;
    /**
     * 单个重量(kg)
     * @type {number}
     * @memberof StockOutboundDetailResVo
     */
    wtKg?: number;
    /**
     * 单品体积(CBM)
     * @type {number}
     * @memberof StockOutboundDetailResVo
     */
    singleCbm?: number;
    /**
     * 总体积(CBM)
     * @type {number}
     * @memberof StockOutboundDetailResVo
     */
    totalCbm?: number;
    /**
     * 订单构成：同种/不同种
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    orderComposition?: string;
    /**
     * 实际使用的库存批次及数量，如 260600231(1)
     * @type {string}
     * @memberof StockOutboundDetailResVo
     */
    batchQuantity?: string;
}

/**
 * Check if a given object implements the StockOutboundDetailResVo interface.
 */
export function instanceOfStockOutboundDetailResVo(value: object): value is StockOutboundDetailResVo {
    return true;
}

export function StockOutboundDetailResVoFromJSON(json: any): StockOutboundDetailResVo {
    return StockOutboundDetailResVoFromJSONTyped(json, false);
}

export function StockOutboundDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockOutboundDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderTypeName': json['orderTypeName'] == null ? undefined : json['orderTypeName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'outboundDate': json['outboundDate'] == null ? undefined : json['outboundDate'],
        'skuNumber': json['skuNumber'] == null ? undefined : json['skuNumber'],
        'packageSpecification': json['packageSpecification'] == null ? undefined : json['packageSpecification'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'singleCbm': json['singleCbm'] == null ? undefined : json['singleCbm'],
        'totalCbm': json['totalCbm'] == null ? undefined : json['totalCbm'],
        'orderComposition': json['orderComposition'] == null ? undefined : json['orderComposition'],
        'batchQuantity': json['batchQuantity'] == null ? undefined : json['batchQuantity'],
    };
}

export function StockOutboundDetailResVoToJSON(json: any): StockOutboundDetailResVo {
    return StockOutboundDetailResVoToJSONTyped(json, false);
}

export function StockOutboundDetailResVoToJSONTyped(value?: StockOutboundDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'orderTypeName': value['orderTypeName'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
        'outboundDate': value['outboundDate'],
        'skuNumber': value['skuNumber'],
        'packageSpecification': value['packageSpecification'],
        'wtKg': value['wtKg'],
        'singleCbm': value['singleCbm'],
        'totalCbm': value['totalCbm'],
        'orderComposition': value['orderComposition'],
        'batchQuantity': value['batchQuantity'],
    };
}

